let __flarum_default_export__;
export default __flarum_default_export__ = (items, mapFn) => {
  if (Array.isArray(items)) {
    return items.filter(Boolean).map(mapFn).filter(Boolean).sort();
  }
  return items ? mapFn(items) : null;
};
flarum.reg.add('fof-drafts', 'forum/utils/fillRelationship', __flarum_default_export__);